/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/authContext";
import { clsx } from "clsx";
import toast from "react-hot-toast";
import { FaRegClipboard } from "react-icons/fa";
import {
  FiMenu,
  FiX,
  FiHome,
  FiBox,
  FiCpu,
  FiSend,
  FiUsers,
  FiLayers,
  FiLogOut,
  FiTrash2,
  FiClock,
  FiDatabase,
} from "react-icons/fi";
import {
  collection,
  where,
  doc,
  getDocs,
  query,
  orderBy,
  runTransaction,
  increment,
} from "firebase/firestore";
import { db, db_modular } from "../../firebaseConfig";
import firebase from "firebase/compat/app";
import Arrow from "../../components/assets/leadingArrow.png";
import logo from "../assets/astra_hack_logo.png";
import dayjs from "dayjs";
import BlockTransactionsModal from "../BlockTransactionsModal";
import KeyDisplay from "./KeyDisplay";
import ParticipantList from "./ParticipantList";

function Content({ user, userData, onSidebarHide }) {
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [role, setRole] = useState(() => localStorage.getItem("role") || "");
  const [team, setTeam] = useState(() => localStorage.getItem("team") || "");
  const [createdBy, setCreatedBy] = useState("");
  const [blueTeamBlocks, setBlueTeamBlocks] = useState([]);
  const [redTeamBlocks, setRedTeamBlocks] = useState([]);
  const [selectedBlockForModal, setSelectedBlockForModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blockCounts, setBlockCounts] = useState({ red: 0, blue: 0 });

  const openBlockModal = (block) => {
    setSelectedBlockForModal(block);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (!roomId) return navigate("/dashboard");

    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const roomData = doc.data();
          setCreatedBy(roomData.createdBy || "");
          setBlockCounts(roomData.blockCounts || { red: 0, blue: 0 });
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  const fetchBlocks = async () => {
    if (!roomId) return;
    try {
      const roomRef = doc(db_modular, "rooms", roomId);

      const redBlocksRes = await getDocs(collection(roomRef, "redTeamBlocks"));
      const redBlocks = redBlocksRes.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setRedTeamBlocks(redBlocks);

      const blueBlocksRes = await getDocs(collection(roomRef, "blueTeamBlocks"));
      const blueBlocks = blueBlocksRes.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setBlueTeamBlocks(blueBlocks);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, [roomId]);

  const handleLeaveRoom = async () => {
    try {
      await db
        .collection("rooms")
        .doc(roomId)
        .update({
          [`${role}s`]: firebase.firestore.FieldValue.arrayRemove(userData?.publicKey),
        });
      localStorage.removeItem("roomId");
      localStorage.removeItem("role");
      localStorage.removeItem("team");
      toast.success("Left the room successfully");
      navigate("/dashboard");
    } catch (error) {
      toast.error("Failed to leave room");
    }
  };

  const handleSwitchTeam = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const newTeam = team === "red" ? "blue" : "red";
      const baseRole = role.split("_").pop(); // 'participant' or 'miner'
      const newRole = `${newTeam}_${baseRole}`;

      const roomRef = db.collection("rooms").doc(roomId);

      await runTransaction(db_modular, async (transaction) => {
        const roomDoc = await transaction.get(doc(db_modular, "rooms", roomId));
        if (!roomDoc.exists()) throw new Error("Room not found");

        transaction.update(doc(db_modular, "rooms", roomId), {
          [`${role}s`]: firebase.firestore.FieldValue.arrayRemove(userData.publicKey),
          [`${newRole}s`]: firebase.firestore.FieldValue.arrayUnion(userData.publicKey),
        });
      });

      localStorage.setItem("team", newTeam);
      localStorage.setItem("role", newRole);
      setTeam(newTeam);
      setRole(newRole);

      toast.success(`Switched to ${newTeam.toUpperCase()} team`);
      window.location.reload();
    } catch (error) {
      console.error("Error switching team:", error);
      toast.error("Failed to switch team");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEndRoom = async () => {
    if (!window.confirm("Are you sure you want to end this room? All data will be deleted."))
      return;
    try {
      const roomDocRef = db.collection("rooms").doc(roomId);
      const subcollections = [
        "blueTeamBlocks",
        "redTeamBlocks",
        "blueTeamTransactions",
        "redTeamTransactions",
      ];

      for (const sub of subcollections) {
        const docs = await roomDocRef.collection(sub).get();
        await Promise.all(docs.docs.map((d) => d.ref.delete()));
      }

      await roomDocRef.delete();
      localStorage.removeItem("roomId");
      localStorage.removeItem("role");
      localStorage.removeItem("team");
      toast.success("Room ended successfully");
      navigate("/dashboard");
    } catch (error) {
      toast.error("Failed to end room");
    }
  };

  const calculateStats = (blocks) => {
    if (blocks.length < 1)
      return { avgTime: 0, avgTxs: 0, minDelay: 0, totalVolume: 0, activeAddresses: 0, tps: 0 };

    // Sort blocks by timestamp ascending for calculations
    const sorted = [...blocks].sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));

    let totalDelay = 0;
    let minDelay = Infinity;
    let totalTxs = 0;
    let totalVolume = 0;
    const receivers = new Set();

    for (let i = 1; i < sorted.length; i++) {
      const delay = sorted[i].timestamp - sorted[i - 1].timestamp;
      totalDelay += delay;
      if (delay < minDelay) minDelay = delay;
    }

    blocks.forEach((b) => {
      b.transactions?.forEach((tx) => {
        totalTxs += 1;
        totalVolume += Number(tx.amount) || 0;
        if (tx.receiver && tx.receiver !== "SYSTEM" && tx.receiver !== "Block Reward") {
          receivers.add(tx.receiver);
        }
      });
    });

    return {
      avgTime: sorted.length > 1 ? Math.round(totalDelay / (sorted.length - 1)) : 0,
      avgTxs: (totalTxs / blocks.length).toFixed(1),
      minDelay: minDelay === Infinity ? 0 : minDelay,
      totalVolume: totalVolume.toFixed(0),
      activeAddresses: receivers.size,
      tps: (totalTxs / (totalDelay || 1)).toFixed(2),
    };
  };

  const redStats = calculateStats(redTeamBlocks);
  const blueStats = calculateStats(blueTeamBlocks);

  const copyToClipboard = (data) => {
    navigator.clipboard.writeText(data).then(() => toast.success("Copied to clipboard"));
  };

  return (
    <div className="w-full space-y-8">
      {/* Top Section: Profile & Room Info */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* User Profile Card */}
        <div className="lg:col-span-1 glass-card p-6 flex flex-col justify-between h-full">
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white text-3xl font-bold shadow-lg shadow-primary/20">
                {userData?.email?.charAt(0).toUpperCase()}
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">{userData?.email || "User"}</h3>
                <div className="flex items-center gap-2 text-text-muted text-sm px-2 py-0.5 rounded-full bg-white/5 w-fit mt-1">
                  <span
                    className={clsx(
                      "w-2 h-2 rounded-full",
                      team === "red" ? "bg-red-500" : "bg-blue-500"
                    )}
                  ></span>
                  {team.toUpperCase()} TEAM • {role.replace("_", " ").toUpperCase()}
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-white/5 rounded-xl p-4 border border-white/5">
                <div className="text-text-muted text-xs uppercase tracking-wider mb-1 flex items-center justify-between">
                  Balance
                  <span className="text-secondary text-lg">
                    {(userData?.balance || 0).toFixed(2)} ASTRA
                  </span>
                </div>
              </div>

              <div className="space-y-3">
                <KeyDisplay
                  label="Room Key"
                  value={roomId}
                  color="text-primary"
                  onCopy={copyToClipboard}
                />
                <KeyDisplay
                  label="Your Public Key"
                  value={userData?.publicKey}
                  color="text-emerald-400"
                  onCopy={copyToClipboard}
                />
                <KeyDisplay
                  label="Your Private Key"
                  value={userData?.privateKey}
                  color="text-amber-400"
                  onCopy={copyToClipboard}
                  isPrivate={true}
                />
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-white/5 flex flex-col gap-3">
            <button
              onClick={handleSwitchTeam}
              disabled={isLoading}
              className="w-full px-4 py-3 rounded-xl bg-primary/10 text-primary hover:bg-primary hover:text-white font-semibold transition-all flex items-center justify-center gap-2 border border-primary/30"
            >
              <FiUsers /> {isLoading ? "Switching..." : "Switch Team"}
            </button>
            <div className="flex gap-4">
              {createdBy === user?.email ? (
                <button
                  onClick={handleEndRoom}
                  className="flex-1 px-4 py-3 rounded-xl bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white font-semibold transition-all flex items-center justify-center gap-2 border border-red-500/30"
                >
                  <FiTrash2 /> End Room
                </button>
              ) : (
                <button
                  onClick={handleLeaveRoom}
                  className="flex-1 px-4 py-3 rounded-xl bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white font-semibold transition-all flex items-center justify-center gap-2 border border-red-500/30"
                >
                  <FiLogOut /> Leave Room
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Block Counters and Stats */}
        <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6 h-full">
          <StatsSection
            team="red"
            count={blockCounts.red}
            stats={redStats}
            blocks={redTeamBlocks}
          />
          <StatsSection
            team="blue"
            count={blockCounts.blue}
            stats={blueStats}
            blocks={blueTeamBlocks}
          />
        </div>
      </div>

      {/* Teams / Participants Section */}
      <div className="glass-card flex flex-col border-primary/20 bg-primary/5 overflow-hidden">
        <div className="px-6 py-3 border-b border-white/5 flex items-center gap-3 bg-white/5">
          <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center text-primary shrink-0">
            <FiUsers size={16} />
          </div>
          <div className="min-w-0">
            <h2 className="text-base font-bold text-white truncate uppercase tracking-wider">
              Room Participants
            </h2>
            <p className="text-text-muted text-xs truncate opacity-60">
              Active members and miners in the network
            </p>
          </div>
        </div>

        <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <ParticipantList
            title="Red Team Participants"
            roomId={roomId}
            team="red"
            userTeam={team}
            type="participants"
            currentUserPk={userData?.publicKey}
          />
          <ParticipantList
            title="Blue Team Participants"
            roomId={roomId}
            team="blue"
            userTeam={team}
            type="participants"
            currentUserPk={userData?.publicKey}
          />
          <ParticipantList
            title="Red Team Miners"
            roomId={roomId}
            team="red"
            userTeam={team}
            type="miners"
            currentUserPk={userData?.publicKey}
          />
          <ParticipantList
            title="Blue Team Miners"
            roomId={roomId}
            team="blue"
            userTeam={team}
            type="miners"
            currentUserPk={userData?.publicKey}
          />
        </div>
      </div>

      {/* Blocks Section */}
      <div className="space-y-8">
        <BlockDisplay
          title="Red Team Blockchain"
          blocks={redTeamBlocks}
          team="red"
          onBlockClick={openBlockModal}
        />
        <BlockDisplay
          title="Blue Team Blockchain"
          blocks={blueTeamBlocks}
          team="blue"
          onBlockClick={openBlockModal}
        />
      </div>

      <BlockTransactionsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        block={selectedBlockForModal}
        team={
          selectedBlockForModal
            ? redTeamBlocks.some((b) => b.hash === selectedBlockForModal.hash)
              ? "red"
              : "blue"
            : "red"
        }
      />
    </div>
  );
}

function BlockDisplay({ title, blocks, team, onBlockClick }) {
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // scroll-fast
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="glass-card flex flex-col border-primary/20 bg-primary/5 overflow-hidden">
      <div className="px-6 py-3 border-b border-white/5 flex items-center justify-between bg-white/5">
        <div className="flex items-center gap-3">
          <div
            className={clsx(
              "w-8 h-8 rounded-lg flex items-center justify-center shrink-0",
              team === "red" ? "bg-red-500/20 text-red-400" : "bg-blue-500/20 text-blue-400"
            )}
          >
            <FiLayers size={16} />
          </div>
          <h3 className="text-base font-bold text-white uppercase tracking-wider">{title}</h3>
        </div>
        <span className="text-xs font-mono text-text-muted opacity-60 bg-black/40 px-3 py-1 rounded-full border border-white/5">
          {blocks.length} Blocks
        </span>
      </div>

      <div className="p-6">
        <div
          ref={scrollRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          className={clsx(
            "flex gap-6 overflow-x-auto pb-4 custom-scrollbar scroll-smooth cursor-grab active:cursor-grabbing select-none",
            isDragging && "scroll-auto"
          )}
        >
          {blocks.length === 0 ? (
            <div className="w-full h-40 flex flex-col items-center justify-center text-text-muted border-dashed border-2 border-white/5 rounded-2xl bg-black/10">
              <FiBox size={32} className="opacity-10 mb-2" />
              <p className="text-sm font-medium">Wait for first block creation</p>
            </div>
          ) : (
            blocks.map((block, i) => (
              <div
                key={block.id}
                className="flex items-center gap-6 group shrink-0"
                onClick={() => onBlockClick(block)}
              >
                <div
                  className={clsx(
                    "w-80 glass-card p-5 border transition-all cursor-pointer hover:border-primary/50 hover:bg-white/10 shadow-lg",
                    team === "red" ? "border-red-400/20" : "border-blue-400/20",
                    i === 0 ? "ring-1 ring-primary/50" : "border-white/5"
                  )}
                >
                  <div className="flex justify-between items-center mb-4 pb-2 border-b border-white/5">
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-bold text-text-muted uppercase tracking-widest">
                        Block #{blocks.length - 1 - i}
                      </span>
                    </div>
                    <div
                      className={clsx(
                        "w-2 h-2 rounded-full",
                        team === "red"
                          ? "bg-red-500 shadow-[0_0_8px_red]"
                          : "bg-blue-500 shadow-[0_0_8px_blue]"
                      )}
                    ></div>
                  </div>

                  <div className="space-y-4">
                    <BlockField label="Hash" value={block.hash} color="text-primary" />
                    <BlockField
                      label="Prev Hash"
                      value={block.previousBlockHash || "GENESIS"}
                      isGenesis={!block.previousBlockHash}
                    />
                    <BlockField
                      label="Timestamp"
                      value={
                        block.timestamp
                          ? typeof block.timestamp === "number"
                            ? dayjs.unix(block.timestamp).format("MMM DD, YYYY HH:mm:ss")
                            : dayjs(block.timestamp).format("MMM DD, YYYY HH:mm:ss")
                          : "N/A"
                      }
                    />

                    <div className="grid grid-cols-2 gap-3 pt-2">
                      <div className="bg-white/5 rounded-lg p-2.5 border border-white/5">
                        <p className="text-[10px] text-text-muted uppercase font-bold mb-1">
                          Nonce
                        </p>
                        <p className="text-sm font-mono text-white">{block.nonce}</p>
                      </div>
                      <div className="bg-white/5 rounded-lg p-2.5 border border-white/5">
                        <p className="text-[10px] text-text-muted uppercase font-bold mb-1">TXs</p>
                        <p className="text-sm font-mono text-white">
                          {block.transactions?.length || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {i < blocks.length - 1 && (
                  <div className="flex items-center">
                    <div
                      className={clsx(
                        "w-16 h-1 rounded-full",
                        team === "red"
                          ? "bg-gradient-to-r from-red-500/60 to-red-400/40"
                          : "bg-gradient-to-r from-blue-500/60 to-blue-400/40"
                      )}
                    ></div>
                    <div
                      className={clsx(
                        "w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent",
                        team === "red"
                          ? "border-l-[10px] border-l-red-400/60"
                          : "border-l-[10px] border-l-blue-400/60"
                      )}
                    ></div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

function BlockField({ label, value, color = "text-text-muted", isGenesis = false }) {
  return (
    <div className="space-y-1">
      <p className="text-[10px] text-text-muted uppercase font-bold ml-1">{label}</p>
      <div
        className={clsx(
          "bg-surface/50 rounded-lg px-2.5 py-1.5 text-[11px] font-mono truncate border border-white/5",
          isGenesis ? "text-secondary font-bold" : color
        )}
      >
        {value}
      </div>
    </div>
  );
}

function StatsSection({ team, count, stats, blocks }) {
  const isRed = team === "red";
  const accentColor = isRed ? "text-red-400" : "text-blue-400";
  const bgColor = isRed ? "bg-red-500/5" : "bg-blue-500/5";
  const borderColor = isRed ? "border-red-500/20" : "border-blue-500/20";
  const barColor = isRed ? "bg-red-500" : "bg-blue-500";

  // Take last 10 blocks for the graph
  const recentBlocks = [...blocks].slice(0, 12).reverse();
  const maxTxs = Math.max(...recentBlocks.map((b) => b.transactions?.length || 0), 5);

  return (
    <div className={clsx("glass-card p-6 border flex flex-col gap-5 h-full", borderColor, bgColor)}>
      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <h4 className={clsx("text-lg flex items-center gap-2 tracking-tight", accentColor)}>
            <FiLayers /> {isRed ? "RED" : "BLUE"} CHAIN
          </h4>
          <div className="flex items-center gap-1.5 mt-0.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="text-[9px] text-emerald-500 uppercase tracking-widest">Live Node</span>
          </div>
        </div>
        <div
          className={clsx(
            "px-3 py-1 rounded-full text-xs border bg-black/40",
            borderColor,
            accentColor
          )}
        >
          {count} {count === 1 ? "BLOCK" : "BLOCKS"}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-y-6 gap-x-4 relative z-10">
        <StatItem
          icon={<FiClock className="opacity-50" />}
          label="Avg Time"
          value={`${stats.avgTime}s`}
          sub="Block Delta"
        />
        <StatItem
          icon={<FiLayers className="opacity-50" />}
          label="Avg TXs"
          value={stats.avgTxs}
          sub="Per Block"
        />
        <StatItem
          icon={<FiDatabase className="opacity-50" />}
          label="Volume"
          value={`${stats.totalVolume}`}
          sub="Total Astra"
        />
        <StatItem
          icon={<FiUsers className="opacity-50" />}
          label="Miners"
          value={stats.activeAddresses || 0}
          sub="Active"
        />
        <StatItem
          icon={<FiHome className="opacity-50" />}
          label="Delay"
          value={`${stats.minDelay}s`}
          sub="Min Mining"
        />
        <StatItem
          icon={<FiCpu className="opacity-50" />}
          label="Network"
          value={`${stats.tps}`}
          sub="Avg TPS"
        />
      </div>

      {/* Activity Line Chart */}
      <div className="pt-6 border-t border-white/5 flex-1 flex flex-col min-h-[300px]">
        <p className="text-[10px] text-text-muted uppercase tracking-[0.2em] mb-6 flex justify-between items-center opacity-70">
          Propelled Activity Trend
          <span className="lowercase opacity-40">node sync: active</span>
        </p>
        <div className="flex-1 relative px-1 group/chart min-h-[220px]">
          <svg className="w-full h-full overflow-visible" preserveAspectRatio="none">
            <defs>
              <linearGradient id={`gradient-${team}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={isRed ? "#f87171" : "#60a5fa"} stopOpacity="0.4" />
                <stop offset="100%" stopColor={isRed ? "#f87171" : "#60a5fa"} stopOpacity="0" />
              </linearGradient>
            </defs>

            {/* Simple Grid Lines */}
            <line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              stroke="white"
              strokeOpacity="0.05"
              strokeWidth="1"
            />
            <line
              x1="0"
              y1="50%"
              x2="100%"
              y2="50%"
              stroke="white"
              strokeOpacity="0.05"
              strokeWidth="1"
            />
            <line
              x1="0"
              y1="100%"
              x2="100%"
              y2="100%"
              stroke="white"
              strokeOpacity="0.05"
              strokeWidth="1"
            />

            {/* Area Fill */}
            <path
              d={generatePath(recentBlocks, maxTxs, true)}
              fill={`url(#gradient-${team})`}
              className="transition-all duration-1000 ease-in-out"
            />

            {/* Main Line */}
            <path
              d={generatePath(recentBlocks, maxTxs)}
              fill="none"
              stroke={isRed ? "#f87171" : "#60a5fa"}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="transition-all duration-1000 ease-in-out"
            />
          </svg>

          {/* Tooltip Overlay Dots */}
          <div className="absolute inset-0 flex items-end gap-1.5 h-full px-1">
            {recentBlocks.map((b, idx) => {
              const txCount = b.transactions?.length || 0;
              const bottom = (txCount / maxTxs) * 100;
              return (
                <div key={b.id || idx} className="flex-1 group/dot relative h-full">
                  <div
                    className={clsx(
                      "absolute w-2.5 h-2.5 rounded-full border-2 border-surface -translate-x-1/2 left-1/2 opacity-0 transition-all z-10"
                    )}
                    style={{ bottom: `calc(${bottom}% - 5px)` }}
                  />
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-surface/90 backdrop-blur-md border border-white/10 px-2 py-1 rounded text-[9px] font-bold opacity-0 group-hover/dot:opacity-100 transition-all whitespace-nowrap z-20 pointer-events-none shadow-2xl scale-95 group-hover/dot:scale-100">
                    Block {b.index}: {txCount} TXs
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function generatePath(blocks, max, isArea = false) {
  if (blocks.length === 0) return "";

  // Handle single block case
  if (blocks.length === 1) {
    const txCount = blocks[0].transactions?.length || 0;
    const y = 100 - (txCount / max) * 100;
    if (isArea) {
      return `M 0,${y} L 100,${y} L 100,100 L 0,100 Z`;
    }
    return `M 0,${y} L 100,${y}`;
  }

  const points = blocks.map((b, i) => {
    const x = (i / Math.max(blocks.length - 1, 1)) * 100;
    const y = 100 - ((b.transactions?.length || 0) / max) * 100;
    return `${x},${y}`;
  });

  let path = `M ${points[0]}`;
  for (let i = 1; i < points.length; i++) {
    const [x0, y0] = points[i - 1].split(",").map(Number);
    const [x1, y1] = points[i].split(",").map(Number);
    const cx = (x0 + x1) / 2;
    path += ` C ${cx},${y0} ${cx},${y1} ${x1},${y1}`;
  }

  if (isArea) {
    path += ` L 100,100 L 0,100 Z`;
  }
  return path;
}

function StatItem({ label, value, sub, icon }) {
  return (
    <div className="space-y-1.5 group/stat">
      <div className="flex items-center gap-1.5 min-w-0">
        {icon && (
          <span className="text-text-muted group-hover/stat:text-white transition-colors">
            {icon}
          </span>
        )}
        <p className="text-[10px] text-text-muted uppercase tracking-wider truncate">{label}</p>
      </div>
      <p className="text-xl text-white tracking-tight">{value}</p>
      <p className="text-[9px] text-text-muted opacity-60 uppercase tracking-tighter">{sub}</p>
    </div>
  );
}

export default function HackRoomDashBoard() {
  const { userData, user } = UserAuth();

  return <Content user={user} userData={userData} onSidebarHide={() => {}} />;
}
